import * as React from "react";
const SvgFiRrHeat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-heat_svg__a)">
      <path
        fill="#062147"
        d="M20.016 24a1 1 0 0 1-.964-1.269c.116-.419.247-.808.377-1.19 1.285-2.685.18-6.684-1.256-8.555a12.31 12.31 0 0 1-.814-12.41 1 1 0 0 1 1.811.848 10.31 10.31 0 0 0 .686 10.483c1.675 2.137 2.986 7.113 1.467 10.271a22 22 0 0 0-.345 1.091 1 1 0 0 1-.962.731m-7 0a1 1 0 0 1-.964-1.269c.116-.419.247-.808.377-1.19 1.285-2.685.18-6.684-1.256-8.555a12.31 12.31 0 0 1-.814-12.41 1 1 0 0 1 1.811.848 10.31 10.31 0 0 0 .686 10.483c1.675 2.137 2.986 7.113 1.467 10.271a22 22 0 0 0-.345 1.091 1 1 0 0 1-.962.731m-7 0a1 1 0 0 1-.964-1.269c.116-.419.247-.808.377-1.19 1.285-2.685.18-6.684-1.256-8.555A12.31 12.31 0 0 1 3.359.576a1 1 0 0 1 1.811.848 10.31 10.31 0 0 0 .686 10.483c1.675 2.137 2.986 7.113 1.467 10.271a22 22 0 0 0-.345 1.091 1 1 0 0 1-.962.731"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-heat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHeat;
